import { appVersion } from '@/version';
import styles from './AppVersion.module.css';

type AppVersionProps = {
  label?: string;
  className?: string;
};

export const AppVersion = ({ label = 'Version', className }: AppVersionProps) => (
  <div className={`${styles.badge} ${className ?? ''}`.trim()} aria-label="App version">
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{appVersion}</span>
  </div>
);
